// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SlickCarousel_wrapper__NJBQw"};